import { render } from "./ControlTable_mobile.vue?vue&type=template&id=a9878946"
import script from "./ControlTable_mobile.vue?vue&type=script&lang=js"
export * from "./ControlTable_mobile.vue?vue&type=script&lang=js"

import "./ControlTable_mobile.vue?vue&type=style&index=0&id=a9878946&lang=css"

import exportComponent from "C:\\Users\\toru-ota\\source\\repos\\Marron\\Jarvis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__